var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinStation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.04 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1{opacity:0.3;}\r\n      .cls-3{fill-rule:evenodd;}\r\n      .cls-3{fill:#000;}\r\n      .cls-4{fill:#fff;}\r\n      .cls-5 {fill: #191919;}\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gr\xF6n b\xE4rgare") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4rgningsbilar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.69,33.73C40.4,35.79,22.68,46.42,18,57.39,13.49,68.15,32.92,101,32.92,101s45.7-36.22,51.55-48.39C90.53,40,78.41,31.51,58.69,33.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.08,0A33,33,0,0,0,0,32.94c0,18.19,33.08,68,33.08,68s33.08-49.85,33.08-68A33,33,0,0,0,33.08,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 33,
    cy: 33,
    r: 24
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M633.5,417.324h1.656a0.867,0.867,0,0,0,.593-1.474l-7.156-6.6a0.821,0.821,0,0,0-1.186,0l-7.162,6.6a0.866,0.866,0,0,0,.593,1.474h1.543V424h3.967v-3.734h3.312V424h3.84v-6.676Z",
    transform: "translate(-1013.3 -662) scale(1.666)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinStation);
export default __webpack_public_path__ + "static/media/PinStation.94ebef8575cac371b26036ab6e99ca19.svg";
export { ForwardRef as ReactComponent };